import DefaultController from './../../controller';
import {createObjectFromDefault} from './../../functions';

class ClipPath extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, Blueprint);
        this.type = 'clipPath'; 
        this.blueprint = createObjectFromDefault(blueprint, this.blueprint);

    }

}


let Blueprint = {
    type: ClipPath,
    properties: {  },
    children: [  ]
}

export default Blueprint;
export {ClipPath as Controller, Blueprint};